module.exports = __webpack_public_path__ + "static/map-06647284db973ae3d6beb0e172f11677.png";